import { startCase, toLower, unescape } from "lodash";
import DOMPurify from 'dompurify'

export function toTitleCase(s: string) {
  return startCase(toLower(s))
}

export function humanize(s: string) {
  return s.replace('_', ' ')
}

export function stripHtml(html: string) {
  return DOMPurify.sanitize(unescape(html), {ALLOWED_TAGS: [], ALLOWED_ATTR: []})
    .replace(/&[a-zA-Z]+;/g, '')
    .replace(/\W+/g, ' ')
}
